export const environment = {
  production: false,
  ApiAppUrl: 'https://pnaubapitest.clavisco.com/',
  ApiUIUrl: 'https://pnaubtest.clavisco.com/',
  env : 'Staging',
  recatchaSiteKey: '6Lf6MUorAAAAABoPD6pyUWWEM5uwzvLazV86CVtb',
  LogRocketId: ''
};
